
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ConvertEverythingSection } from "@/sections/ConvertEverythingSection";
import { TryBeforeYouBuySection } from "@/sections/TryBeforeYouBuySection";
import { ConversionSection } from "@/sections/ConversionSection";

import { VideoSection } from "@/sections/VideoSection";
import Trans from "next-translate/Trans";

const SketchToFigma = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/SketchToFigma"
        ogImage="/images/sketch2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/SketchToFigma:title")}
        subtitle={t("page/SketchToFigma:subtitle")}
        magicianLogoFile="figma"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConvertEverythingSection
        images={[
          {
            src:
              "/svgs/convert-everything/symbols-components-sketch-to-figma.svg",
            alt: "symbols/components",
          },
          {
            src:
              "/svgs/convert-everything/prototyping-transitions-sketch-to-figma.svg",
            alt: "Prototyping for Sketch to Figma",
          },
          {
            src: "/svgs/convert-everything/text-and-colors-figma.svg",
            alt: "text-and-colors",
          },
        ]}
      />
      <TryBeforeYouBuySection
        title={t("page/SketchToFigma:section/tryBeforeBuy.title")}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "BOX",
            text: t(
              "page/SketchToFigma:section/tryBeforeBuy.elements.firstElementText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "SHIELD",
            text: t(
              "page/SketchToFigma:section/tryBeforeBuy.elements.secondElementText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "LOCK",
            text: t(
              "page/SketchToFigma:section/tryBeforeBuy.elements.thirdElementText",
            ),
          },
        ]}
        cta={{
          title: t("page/SketchToFigma:section/tryBeforeBuy.actionLabel"),
        }}
      />
      <VideoSection
        title={t("page/SketchToFigma:section/videoSection.title")}
        subtitle={
          ((
            <Trans
              i18nKey="page/SketchToFigma:section/videoSection.subtitle"
              components={[<b key={0} />]}
            />
          ) as unknown) as string
        }
        media={{
          type: "PHOTO",
          src: "/images/sketch-to-figma-preview.jpg",
          title: "Sketch To Figma Preview",
        }}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "SKETCH",
            image: "/images/sketch-preview.jpg",
            title: "Sketch Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/figma-preview.jpg",
            title: "Figma Demo Preview",
          },
        }}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default SketchToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/sketch-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  